import ReactDOM from 'react-dom';
import AISolutionsAdvisor from './components/AISolutionsAdvisor';
import normalizeWidgetInput from 'src/common/normalizeWidgetInput';
import widgetDefinition from './aisolutionsadvisor.widget';
import { RenderFn } from 'src/types/widgets';
import 'carbon-components/css/carbon-components.min.css';
import { Provider } from 'react-redux';
import { store } from './lib/redux/store';
import { TranslationProvider } from '../../common/components/TranslationProvider/TranslationProvider';
import { IntlProvider } from 'react-intl';

const render: RenderFn = async function (instanceId, langCode, _origin, cb) {
  const { element, locale, messages } = await normalizeWidgetInput(
    instanceId,
    langCode,
    widgetDefinition,
  );
  if (!element || !locale || !messages) {
    return;
  }
  const localeCode = element.getAttribute('data-localecode') || 'en-us';

  ReactDOM.render(
    <Provider store={store}>
      <IntlProvider locale="en" defaultLocale="en">
        <TranslationProvider messages={messages}>
          <AISolutionsAdvisor
            element={element}
            langCode={localeCode}
            test={false}
            countryToTest={'us'}
          />
        </TranslationProvider>
      </IntlProvider>
    </Provider>,
    element,
    () => cb(element),
  );
};

export default render;
